import script from "./GardenPlaceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GardenPlaceForm.vue?vue&type=script&setup=true&lang=js"

import "./GardenPlaceForm.vue?vue&type=style&index=0&id=93d35e98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93d35e98"]])

export default __exports__